class SweetAlert {
    static alert(options) {
        return swal(options);
    }

    static alertSuccess({title = "Success!", text = "That's all done!", timer = 2000, showConfirmationButton = true} = {}) {
        return this.alert({
            title: title,
            text: text,
            timer: timer,
            showConfirmButton: showConfirmationButton,
            icon: 'success'
        });
    }

    static alertError({title = "Error!", text = "Oops... Something went wrong"} = {}) {
        if (! window.store.state.onlineStatus.web) {
            text += '\n\nYou do not appear to be connected to the internet.'
        } else if (! window.store.state.onlineStatus.api) {
            text += '\n\nCould not communicate with the API, but internet connection seems OK.'
        }

        return this.alert({
            title: title,
            text: text,
            icon: 'error'
        });
    }

    static confirm(options) {
        options = Object.assign({
            title: "Are you sure?",
            text: "Are you sure you want to do that?",
            icon: "warning",
            closeModal: true
        }, options);

        return swal(options);
    }
}

export default SweetAlert;
